import { create } from 'zustand';
import type { Room } from '@/types/room.types';

interface Participant {
  id: string;
  name: string;
  isLocal: boolean;
}

interface RoomState {
  currentRoom: Room | null;
  participants: Participant[];
  isOwner: boolean;
  setRoom: (room: Room) => void;
  setParticipants: (participants: Participant[]) => void;
  addParticipant: (participant: Participant) => void;
  removeParticipant: (id: string) => void;
  clearRoom: () => void;
}

export const useRoomStore = create<RoomState>((set) => ({
  currentRoom: null,
  participants: [],
  isOwner: false,
  setRoom: (room) => set({ currentRoom: room, isOwner: room.isOwner }),
  setParticipants: (participants) => set({ participants }),
  addParticipant: (participant) =>
    set((state) => ({
      participants: [...state.participants, participant],
    })),
  removeParticipant: (id) =>
    set((state) => ({
      participants: state.participants.filter((p) => p.id !== id),
    })),
  clearRoom: () => set({ currentRoom: null, participants: [], isOwner: false }),
}));
